import { jsx as r } from "react/jsx-runtime";
import { I as t } from "./chunks/index-CpGuKBKg.js";
import { r as s } from "./chunks/resolveConfig-BryMA7OT.js";
import l from "./preset.js";
const { theme: o } = s(l), m = (e) => /* @__PURE__ */ r(
  t,
  {
    toastOptions: {
      icon: null,
      style: {
        fontWeight: "bold",
        fontFamily: o.fontFamily.secondary,
        fontSize: o.fontSize.large,
        color: o.colors.white,
        textAlign: "center"
      },
      error: {
        style: {
          backgroundColor: o.colors.rose[600]
        }
      },
      success: {
        style: {
          backgroundColor: o.colors.emerald[400]
        }
      }
    },
    ...e
  }
);
export {
  m as default
};
